export const SET_IS_PENDING = 'rpb2b-react/model/SET_IS_PENDING';
export type SET_IS_PENDING = typeof SET_IS_PENDING;

export const SET_UPDATING = 'rpb2b-react/model/SET_UPDATING';
export type SET_UPDATING = typeof SET_UPDATING;

export const SET_DELIVER_METHOD = 'rpb2b-react/cart/SET_DELIVER_METHOD';
export type SET_DELIVER_METHOD = typeof SET_DELIVER_METHOD;

export const SET_DELIVER_TO = 'rpb2b-react/cart/SET_DELIVER_TO';
export type SET_DELIVER_TO = typeof SET_DELIVER_TO;

export const SET_DELIVERY_LOCATION_CODE =
  'rpb2b-react/cart/SET_DELIVERY_LOCATION_CODE';
export type SET_DELIVERY_LOCATION_CODE = typeof SET_DELIVERY_LOCATION_CODE;

export const SET_SUPPLIED_FROM_CODE = 'rpb2b-react/cart/SET_SUPPLIED_FROM_CODE';
export type SET_SUPPLIED_FROM_CODE = typeof SET_SUPPLIED_FROM_CODE;

export const SET_SUBTOTAL = 'rpb2b-react/cart/SET_SUBTOTAL';
export type SET_SUBTOTAL = typeof SET_SUBTOTAL;

export const SET_ITEMS_COUNT = 'rpb2b-react/cart/SET_ITEMS_COUNT';
export type SET_ITEMS_COUNT = typeof SET_ITEMS_COUNT;

export const ITEM_REMOVE = 'rpb2b-react/cart/ITEM_REMOVE';
export type ITEM_REMOVE = typeof ITEM_REMOVE;

export const SET_ITEMS = 'rpb2b-react/cart/SET_ITEMS';
export type SET_ITEMS = typeof SET_ITEMS;

export const SET_ERROR = 'rpb2b-react/cart/SET_ERROR';
export type SET_ERROR = typeof SET_ERROR;

export const CLEAR_ALL = 'rpb2b-react/cart/CLEAR_ALL';
export type CLEAR_ALL = typeof CLEAR_ALL;

export const ADD_SIMPLE_ITEM = 'rpb2b-react/cart/ADD_SIMPLE_ITEM';
export type ADD_SIMPLE_ITEM = typeof ADD_SIMPLE_ITEM;

export const ADD_ITEM = 'rpb2b-react/cart/ADD_ITEM';
export type ADD_ITEM = typeof ADD_ITEM;

export const SET_SUCCESS_CART = 'rpb2b-react/lists/SET_SUCCESS_CART';
export type SET_SUCCESS_CART = typeof SET_SUCCESS_CART;

export const SET_CART_IS_DOWNLOADING_PDF =
  'rpb2b-react/lists/SET_CART_IS_DOWNLOADING_PDF';
export type SET_CART_IS_DOWNLOADING_PDF = typeof SET_CART_IS_DOWNLOADING_PDF;
export const SET_IS_PENDING_LISTS = 'rpb2b-react/lists/SET_IS_PENDING_LISTS';
export type SET_IS_PENDING_LISTS = typeof SET_IS_PENDING_LISTS;

export const SET_IS_PENDING_FILE_STATUS =
  'rpb2b-react/lists/SET_IS_PENDING_LISTS';
export type SET_IS_PENDING_FILE_STATUS = typeof SET_IS_PENDING_FILE_STATUS;

export default {
  SET_IS_PENDING,
  SET_UPDATING,
  SET_DELIVER_METHOD,
  SET_DELIVER_TO,
  SET_DELIVERY_LOCATION_CODE,
  SET_SUPPLIED_FROM_CODE,
  SET_SUBTOTAL,
  SET_ITEMS_COUNT,
  ITEM_REMOVE,
  SET_ITEMS,
  SET_ERROR,
  CLEAR_ALL,
  ADD_SIMPLE_ITEM,
  ADD_ITEM,
  SET_SUCCESS_CART,
  SET_CART_IS_DOWNLOADING_PDF,
  SET_IS_PENDING_LISTS,
  SET_IS_PENDING_FILE_STATUS
};
